import React from "react";
import { Monitor, Megaphone, TrendingUp, ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../../mock";

const ICONS = { Monitor, Megaphone, TrendingUp };

export default function Services() {
  return (
    <section id="services" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="section-eyebrow">Services</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
              Web design &amp; social media marketing in Hamilton &amp; Motherwell.
            </h2>
          </div>
          <p className="text-slate-600 max-w-md">
            Three focused practices, one senior team. We can run a single
            project or act as your long-term digital partner.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <div
                key={s.id}
                className="group card-lift relative rounded-3xl border border-slate-200 bg-white p-7 lg:p-8 flex flex-col hover:border-sky-200"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-slate-900 to-slate-700 text-white flex items-center justify-center ring-4 ring-sky-50">
                    <Icon className="h-5 w-5" />
                  </div>
                  <span className="text-xs tracking-widest text-sky-500 font-semibold">
                    {s.id}
                  </span>
                </div>

                <h3 className="text-xl lg:text-2xl font-semibold text-slate-900 leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-slate-600 text-sm leading-relaxed">
                  {s.description}
                </p>

                <ul className="mt-6 space-y-2.5">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-2.5 text-sm text-slate-700"
                    >
                      <Check className="h-4 w-4 text-sky-600 mt-0.5 shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <a
                  href="#contact"
                  className="mt-8 inline-flex items-center gap-1.5 text-sm font-medium text-slate-900 btn-link"
                >
                  Discuss a project
                  <ArrowUpRight className="h-4 w-4 btn-arrow" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
